<template>
    <div class="navbar-custom">
        <ul class="list-unstyled topnav-menu float-right mb-0">
            <div class="dropdown notification-list">
                <a class="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                    <img src="assets/images/building.png" alt="company-image" class="rounded-circle" />
                    <span class="pro-user-name ml-1" v-if="companyName"> {{ companyName }} <i class="mdi mdi-chevron-down"></i> </span>
                </a>
                <div class="dropdown-menu dropdown-menu-right profile-dropdown">
                    <a href="javascript:void(0);" class="dropdown-item notify-item">
                        <i class="dripicons-user"></i>
                        <span>{{ user.firstName + ' ' + user.lastName }}</span>
                    </a>
                    <a href="javascript:void(0);" class="dropdown-item notify-item" @click="loggout">
                        <i class="dripicons-power" style="color: gray"></i>
                        <span style="color: gray">{{ $t('string.msg.header.label.logout') }}</span>
                    </a>
                </div>
            </div>
        </ul>

        <ul class="list-unstyled menu-left mb-0">
            <li class="float-left" style="position: relative">
                <a class="logo cursor-pointer">
                    <span class="logo-lg mt-1 mr-2">
                        <img src="assets/images/sos_logo.png" alt="Logo S.O.S Truck" height="75" />
                    </span>
                    <span class="logo-sm mt-1">
                        <img src="assets/images/sos_logo_compact.png" alt="Logo S.O.S Truck" height="60" />
                    </span>
                </a>
                <span style="position: absolute; bottom: 0px; right: 0px">
                    <small>
                        <a style="color: white" href="https://www.sostruck.com.br/version.txt" target="_blank">versão {{ appVersion }}</a>
                    </small>
                </span>
            </li>
            <li class="float-left">
                <a class="button-menu-mobile navbar-toggle">
                    <div class="lines">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </a>
            </li>
            <li class="text-center mr-5 mt-1">
                <a href="https://www.itrackbrasil.com.br/" target="_blank"><img src="assets/images/Banner no APP_iTrack.png" alt="iTrack Logo" class="cursor-pointer" height="75" width="380" /></a>
            </li>
            <!-- <li class="text-center mr-5 mt-1" v-if="isFleetDriver == true">
            <span>
                <a href="https://www.itrackbrasil.com.br/" target="_blank"><img src="assets/images/Banner no APP_iTrack.png" alt="iTrack Logo" class="cursor-pointer" height="75" width="380"></a>
            </span>
        </li> -->
        </ul>
    </div>
</template>

<script>
import Controller from './CrtHeader'
import { version } from '../../../../package'
export default {
    name: 'Header',
    components: {
        Controller,
    },
    data() {
        return {
            errors: [],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            companyName: null,
            isFleetDriver: false,
            appVersion: version,
            user: {
                firstName: '',
            },
        }
    },
    methods: Controller.methods,
    created() {},
    mounted() {
        Controller.init(this)
        this.loadUserInfos()
    },
}
</script>

<style scoped>
</style>